import { Component, ChangeDetectorRef } from '@angular/core';
import { Overlay } from '@angular/cdk/overlay';

import { TextFieldComponent } from './text-field.component';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-technical-specs-field-component',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.scss']
})
export class TechSpecsFieldComponent extends TextFieldComponent {

  format: string = "hd"
  hints: string[] = [];
  suffixes: string[] = [];

  set hint(value: string) { }
  get hint(): string { return this.hints[this.format] }
  set suffix(value: string) { }
  get suffix(): string { return this.suffixes[this.format] }

  constructor(
    cd: ChangeDetectorRef,
    overlay: Overlay,
    private authService: AuthService) { super(cd, overlay); }

  ngOnInit() {
    super.ngOnInit();
    if (this.field.hints != null) { this.hints = this.field.hints }
    if (this.field.suffixes != null) { this.suffixes = this.field.suffixes }
  }

  setCategories(categories) {
    this.format = categories != null ? categories[0] : "hd";
    this.cd.markForCheck();
  }

}


// WEBPACK FOOTER //
// ./src/app/forms/tech-specs-field.component.ts